import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/navbar';
import Inicio from './components/inicio';
import Servicios from './components/servicios';
import Footer from './components/footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <div className="content-wrapper">
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/servicios" element={<Servicios />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
